export default __webpack_public_path__ + "static/media/CreateYourOwnMonitor.ff75624d.md";